import { render, staticRenderFns } from "./EconomicStatistics.vue?vue&type=template&id=14454c65&"
import script from "./EconomicStatistics.vue?vue&type=script&lang=js&"
export * from "./EconomicStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports